import { getPlatformStyles } from '@direct-frontend/platform-code';

import { cn } from '../../css/className/className';

getPlatformStyles({
    desktop: import('./getScrollbarClassName.css'),
});

export function getScrollbarClassName() {
    return cn('Scrollbar')();
}
